module.exports = __webpack_public_path__ + "img/dashboardLogo.5cca1ffe.svg";